import Http from "../api/http";

export default class UserPartTime extends Http {
  constructor() {
    super();
  }
  // 加载在线报告
  userPartTime_getReportTemplateExperience() {
    return super.post("userPartTime/getReportTemplateExperience", ...arguments);
  }
  // 审核报告
  userPartTime_auditReport() {
    return super.post("userPartTime/auditReport", ...arguments);
  }
  // 我的审核列表
  userPartTime_getMyAuditList() {
    return super.post("userPartTime/getMyAuditList", ...arguments);
  }
  /**
   * 我的审核列表
   * @param {Array} myReportAuditBO -  myReportAuditBO
   */

  userPartTime_getMyAuditListV3() {
    return super.post("userPartTime/getMyAuditListV3", ...arguments, {});
  }

  // 查看报告详情
  userPartTime_getReportDetail() {
    return super.post("userPartTime/getReportDetail", ...arguments);
  }
  // 获取报告库列表
  userPartTime_getReportLibraryList() {
    return super.post("userPartTime/getReportLibraryList", ...arguments);
  }
  // 常用语列表braryList
  userPartTime_phrasesList() {
    return super.post("userPartTime/phrasesList", ...arguments);
  }
  // 领取报告
  userPartTime_receiveReport() {
    return super.post("userPartTime/receiveReport", ...arguments);
  }

  // 我的收入列表
  userPartTime_getMySalaryList() {
    return super.post("userPartTime/getMySalaryList", ...arguments);
  }

  // 薪资明细
  userPartTime_salaryDetail() {
    return super.post("userPartTime/salaryDetail", ...arguments);
  }
  // 薪资审核明细
  userPartTime_salaryDetailAudit() {
    return super.post("userPartTime/salaryDetailAudit", ...arguments);
  }
  // 薪资奖惩明细
  userPartTime_salaryDetailRewardPunishment() {
    return super.post("userPartTime/salaryDetailRewardPunishment", ...arguments);
  }
  // 获取报告树
  userPartTime_getReportExperience() {
    return super.post("userPartTime/getReportExperience", ...arguments);
  }
  // 获取比较列表
  userPartTime_getReportContrastDetail() {
    return super.post("userPartTime/getReportContrastDetail", ...arguments);
  }
  /**
   * 获取报告树结构或者数组
   * @param {string} reportExperienceId -  用户体验描述id
   */
  userPartTime_getReportExperienceContent() {
    return super.post("userPartTime/getReportExperienceContent", ...arguments);
  }
  // 保存阶段报告树结构或者数组
  userPartTime_saveReportExperiencePhaseContent() {
    return super.post("userPartTime/saveReportExperiencePhaseContent", ...arguments, {});
  }
  // 报告对比详情
  userPartTime_getReportDetailNotCheck() {
    return super.post("userPartTime/getReportDetailNotCheck", ...arguments);
  }
  /**
   * 编辑报告基本信息
   * @param {Array} reportBaseInfoDto -  reportBaseInfoDto
   */

  userPartTime_updateReportBaseInfo() {
    return super.post("userPartTime/updateReportBaseInfo", ...arguments, {});
  }
  /**
   * 兼职是否实名认证嗨探，认证后未签署兼职协议的给签署链接
   * @param {string} userId -  userId
   */

  user_getPartTimeUrl() {
    return super.post("user/getPartTimeUrl", ...arguments);
  }
  /**
   * *导出我的审核列表
   * @param {integer} receiveType - 领取类型 1我领取的 2指定给我的
   * @param {integer} auditType - 报告审核类型 1进行中 2成功 3失败
   * @param {integer} reportStatus - 报告状态 1待审核 2已驳回
   * @param {string} brandName - 品牌名称
   * @param {string} storeName - 门店名称
   * @param {string} taskName - 任务名称
   * @param {string} cityName - 城市名称
   * @param {string} checkTime - 检查日期
   * @param {string} subTime - 提交日期
   * @param {string} uid - 用户Id
   * @param {string} prop - 排序字段 检查日期-checkTime 提交日期-submitTime 报告字数-wordCount
   * @param {string} order - ascending-正序 descending-倒序
   * @param {string} orderColumn - 排序sql拼接
   * @param {integer} myCanAudit - 我是否能审核1是0否
   * @param {integer} rows - 行数
   * @param {integer} page - 页数
   */
  userPartTime_exportMyAuditList() {
    return super.post("userPartTime/exportMyAuditList", ...arguments);
  }
  /**
   * *导出薪资奖惩明细
   * @param {integer} id - id
   */
  userPartTime_exportAuditSalaryAndPunishment() {
    return super.post("userPartTime/exportAuditSalaryAndPunishment", ...arguments);
  }
  /**
   * 获取历史报告
   * @param{string} historyReportId - historyReportId
   */
  userPartTime_getHistoryReportExperience() {
    return super.post("userPartTime/getHistoryReportExperience", ...arguments);
  }
  /**
   * 查看历史报告详情
   * @param{string} historyReportId - historyReportId
   */
  userPartTime_getHistoryReportInfo() {
    return super.post("userPartTime/getHistoryReportInfo", ...arguments);
  }
  /**
   * 获取历史报告的所有录音文件
   * @params{string} historyReportId - historyReportId
   */
  userPartTime_getHistoryReportAllSoundFile() {
    return super.post("userPartTime/getHistoryReportAllSoundFile", ...arguments);
  }
  /**
   * 报告比对
   * @params{string} matchId - matchId
   * @params{string} baseId - baseId
   */
  userPartTime_reportCompare() {
    return super.post("userPartTime/reportCompare", ...arguments);
  }
  /**
   * 审核心跳
   * @params{string} reportLogId - reportLogId
   */
  userPartTime_auditHeartbeat() {
    return super.post("userPartTime/auditHeartbeat", ...arguments);
  }
}
